import React from 'react';
import {withTranslation} from "react-i18next";

let ButtonComponent = ({onButtonClick, textKey, downloading=false, className, t}) => {
	return <button className={className} onClick={onButtonClick} disabled={downloading}>
		{downloading ? t('reward.claim.vouchers.downloading') : t(textKey)}
	</button>;
};

export default withTranslation() (ButtonComponent)